import { Get } from 'src/axios';
import { TEmployee } from 'src/types/shared';

export const getTeamEmployes = () => Get<TEmployee[]>('/team/team_member/');

export const getEmployee = (id: string) =>
  Get<TEmployee>(`/team/team_member/${id}`);
